import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardAvoidingView as ReactNativeKeyboardAvoidingView } from 'react-native';
import { Device } from 'DeviceUtils';

const CustomKeyboardAvoidingView = ({ children, ...props }) => (
    <ReactNativeKeyboardAvoidingView
        style={{ flex: 1 }}
        behavior={Device.isIos ? 'padding' : null}
        keyboardVerticalOffset={Device.isIos ? 80 : 0}
        {...props}
    >
        {children}
    </ReactNativeKeyboardAvoidingView>
);

CustomKeyboardAvoidingView.defaultProps = {
    children: []
};

CustomKeyboardAvoidingView.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default CustomKeyboardAvoidingView;
